import React, { useState, useEffect } from 'react';
import './OfferPopup.css';

type PopupType = 'consultation' | 'video';

export const OfferPopup: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [popupType, setPopupType] = useState<PopupType>('consultation');

  useEffect(() => {
    // Sprawdzamy, czy popup był już otwarty w tej sesji przeglądarki
    const hasSeenPopup = sessionStorage.getItem('pcc_offer_popup_seen');

    if (!hasSeenPopup) {
      const lastShown = localStorage.getItem('pcc_last_popup_type');

      const nextType: PopupType = lastShown === 'consultation' ? 'video' : 'consultation';
      setPopupType(nextType);

      // Opcjonalne lekkie opóźnienie (np. 1.2s), by strona zdążyła się załadować
      const timer = setTimeout(() => {
        setIsOpen(true);
        sessionStorage.setItem('pcc_offer_popup_seen', 'true');
        localStorage.setItem('pcc_last_popup_type', nextType);
      }, 1200);

      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const handleClose = () => {
    setIsOpen(false);
  };

  if (!isOpen) return null;

  const isConsultation = popupType === 'consultation';

  return (
    <div className="pcc-popup-overlay">
      <div className="pcc-popup-modal">
        <button className="pcc-popup-close" onClick={handleClose}>
          ✕
        </button>
        <div className="pcc-popup-image-wrapper">
          <span className="pcc-badge-news">NOWOŚĆ</span>
         <img src={isConsultation 
          ? "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=800&h=400"
          : "https://images.unsplash.com/photo-1587614382346-4ec70e388b28?auto=format&fit=crop&q=80&w=800&h=400"} 
        alt={isConsultation ? "Konsultacje PCC Porada" : "Dostęp do nagrania"} />
        </div>

        <div className="pcc-popup-content">
          <div className="pcc-status-dot">
            <span className="dot"></span> Dostępne od ręki
          </div>

          <h3>{isConsultation ? "Pakiety Konsultacji 7-dniowych" : "Dostęp do nagrania na 1 miesiąc"}</h3>
          <p className="pcc-popup-desc">
            {isConsultation
            ? "Szybkie wsparcie eksperta bez długiego oczekiwania. Zyskaj dedykowaną opiekę i odpowiedzi na pytania przez pełne 7 dni."
            : "Zyskaj natychmiastowy dostęp do specjalistycznej wiedzy. Oglądaj materiał wideo w dowolnym momencie przez pełne 30 dni."}
          </p>

          <div className="pcc-features-box">
            <div className="pcc-feature-item">
              <span className="check-icon">✓</span> {isConsultation ? "Bezpośredni kontakt z ekspertem" : "Oglądasz od razu po zakupie"}
            </div>
            <div className="pcc-feature-item">
              <span className="check-icon">✓</span> Ważność pakietu: <strong>{isConsultation ? "7 dni kalendarzowych" : "1 miesiąc (30 dni)"}</strong>
            </div>
          </div>

          <div className="pcc-popup-actions">
            <button className="pcc-btn-secondary" onClick={handleClose}>
              Później
            </button>
            <a href={isConsultation ? "/consultations" : "/videos"} className="pcc-btn-primary">
              Sprawdź ofertę
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfferPopup;